import { ConfirmDialog } from 'primereact/confirmdialog';

export default ConfirmDialog;
